﻿import './sections.css'
const PossoBuildLogoWhite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 40" style={{ height: '28px', marginBottom: '1rem', display: 'block' }}>
    <rect x="0" y="8" width="24" height="24" rx="4" fill="#c9a84c"/>
    <rect x="4" y="12" width="16" height="3" rx="1.5" fill="#1c2b3a"/>
    <rect x="4" y="18" width="12" height="3" rx="1.5" fill="#1c2b3a"/>
    <rect x="4" y="24" width="8" height="3" rx="1.5" fill="#1c2b3a"/>
    <text x="32" y="27" fontFamily="Inter,Arial,sans-serif" fontSize="18" fontWeight="800" fill="#ffffff">PossoBuild</text>
  </svg>
)
const NAV = {
  Products: ['SmartHire', 'SmartDevelop', 'SmartAssess', 'SmartAssist'],
  Solutions: ['Enterprise', 'Professional Services', 'Healthcare', 'Financial Services'],
  Company: ['About Us', 'Careers', 'Blog', 'Press', 'Contact'],
}
export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <PossoBuildLogoWhite />
            <p>The AI Workforce Intelligence Platform trusted by enterprise teams at Big 4 firms and Fortune 100 corporations.</p>
            <p className="footer-tagline">Transforming every stage of the employee journey with AI.</p>
          </div>
          {Object.entries(NAV).map(([h, links]) => (
            <div key={h} className="footer-col">
              <h4>{h}</h4>
              <ul>
                {links.map(l => <li key={l}><a href="#">{l}</a></li>)}
              </ul>
            </div>
          ))}
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} PossoBuild. All rights reserved.</p>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
            <a href="#">Security</a>
          </div>
        </div>
      </div>
    </footer>
  )
}
